module.exports = __webpack_public_path__ + "img/ing-delivery.b5189ce9.svg";